import { AudioLines, Film, ImageIcon, Type } from 'lucide-react';
import type { ReactNode } from 'react';
import type { LayerKind } from '@/core/project/layers';

/** One glyph per kind of media, wherever it is listed. */
export const LAYER_ICONS: Readonly<Record<LayerKind, (size: number) => ReactNode>> = {
  video: (size) => <Film size={size} />,
  image: (size) => <ImageIcon size={size} />,
  audio: (size) => <AudioLines size={size} />,
  text: (size) => <Type size={size} />,
};
